module.exports = __webpack_public_path__ + "media/site_templates/www.gyprockinstallation.com.au/images/about_us-192bb0ced14f2ec15bf4dc126eab16da.jpg";